const PERMISSION_KEY= "personalize:nebula_perf_fee_amortized";
const PAGE_URL = {
    NEBULA_PERF_FEE_AMORTIZED_PAGE: "/admin/personalize/nebula-perf-fee-amortized"
}

export {PERMISSION_KEY, PAGE_URL}

